import { useMocks } from '../../shared/env';
import type { CompensationGateway } from './CompensationGateway';
import { HttpCompensationGateway } from './HttpCompensationGateway';
import { MockCompensationGateway } from './MockCompensationGateway';

export const compensationGateway: CompensationGateway = useMocks ? new MockCompensationGateway() : new HttpCompensationGateway();
export type { CompensationGateway } from './CompensationGateway';
